import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { toast } from 'react-toastify';
import { renameTraySolutionInstance } from '~/store/connectionManager';

export const effect = createListenerEffect(
  'toastTrayRenamingFailed<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    toast.error('Integration renaming failed. Please try again.');
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: renameTraySolutionInstance.rejected,
  effect,
});

export default middleware;
